// Module
var code = `<p class="docs-item-block-p type-what-is-it">
  <span>What is it?</span>{{text}}
</p>
`;
// Exports
module.exports = code;